module.exports = __webpack_public_path__ + "img/base-info.4c3568c6.svg";